import styles from "./LoadingSpinner.module.scss";
const LoadingSpinner = () => {
  return <div className={styles.loader} />;
};

export default LoadingSpinner;
